import React, {FC} from "react";
import {Helmet} from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionGridPosts from "containers/PageHome/SectionGridPosts";
import {DEMO_POSTS_VIDEO} from "data/posts";
import ButtonPrimary from "../../components/Button/ButtonPrimary";
import {ArrowRightIcon} from "@heroicons/react/solid";
import ButtonSecondary from "../../components/Button/ButtonSecondary";

export interface PageLearnProps {
  className?: string;
}

const PageLearn: FC<PageLearnProps> = ({className = ""}) => {
  return (
    <div
      className={`PageLearn overflow-hidden relative ${className}`}
      data-id="PageLearn"
    >
      <Helmet>
        <title>Learn | CryptoVerse</title>
      </Helmet>

      <div className="relative overflow-hidden">
        <BgGlassmorphism/>

        <div className="container relative">

          <SectionGridPosts
            className="py-16 lg:py-28"
            headingIsCenter
            postCardName="card10V2"
            heading="WEB3 QUESTIONS, ANSWERED"
            subHeading="Beginner guides, practical tips, and market updates for first-timers, experienced investors, and everyone in between 🥡"
            posts={DEMO_POSTS_VIDEO.filter((_, i) => i < 6)}
            gridClass="md:grid-cols-2 lg:grid-cols-3"
          />
          <div className="flex space-x-4 mt-1 justify-center py-10">
            <ButtonPrimary href={"/Markets"}>See The Data <ArrowRightIcon className="w-5 h-5 ml-2"/>
            </ButtonPrimary>
            <ButtonSecondary href={"/blog"}>
              Read The Latest
              <ArrowRightIcon className="w-5 h-5 ml-2"/>
            </ButtonSecondary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLearn;
